"use client"

import { useSearchParams } from "next/navigation"

export const useHasSearchParams = () => {
  const searchParams = useSearchParams()
  return searchParams.size > 0
}
